import React from "react";
import { FormComponent } from "../../../components/form/DynamicForm";
import { Form, Validators } from "../../../components/form/DynamicFormTs";
import { withRouter } from "react-router-dom";
import Http from "../../../Http";
import { objectAsParams } from "../../../helpers";

class BuscarGuia extends FormComponent {
  initial = true;

  componentDidMount() {
    let fields = [
      Form.Field("autocomplete", "id_guia", "Buscar Guia", "", [Validators.required], 12)
    ];
    this.FormConfig(
      {
        defaultUrl: "banco",
        saveUrl: "banco/save",
        backUrl: "/Guias/SeguimientoGuias",
      },
      new Form(fields, ["Buscar"], ""),
      this.formData
    );
    this.setState({ id_guia: false, busquedaGuias: [], guia: false });
  }

  formData = async (form) => {
    const params = {};
    let newForm = form;
    if (this.formGuia) {
      params["guia"] = this.formGuia;
      this.formGuia = null;
    }

    const Res = await Http.get(
      `guia-comentario/form?${objectAsParams(params)}`
    );
    if (!Res.error) {
      const { guias } = Res.data;
      if (guias) {
        newForm = Form.FieldOptions(newForm, "id_guia", guias, "id", "g_folio");
        this.setState({ busquedaGuias: guias });
      }
    }
    newForm = Form.ValueChange(newForm, {
      id_guia: async (field) => {
        field.ValueAt &&
          field.ValueAt.length > 2 &&
          this.guiasChange(field, "formGuia");
      },
    });
    return newForm;
  };

  guiasChange = async (field, variable) => {
    const { busquedaGuias, id_guia, FormData } = this.state;
    let newFormData = FormData;
    if (id_guia !== field.Value) {
      const infoGuia = busquedaGuias.find(opt => opt.id === field.Value);
      if (infoGuia) {
        this.setState({ guia: infoGuia, id_guia: field.Value });
      }
      this.props.onChangeGuia(infoGuia);
    }
    this[variable] = field.ValueAt;
    this.setState({ FormData: await this.formData(newFormData) });
  };

  onSubmit = async (i, vals) => {
    if (this.props.onChangeGuia) {
      const { guia } = this.state;
      this.props.onChangeGuia(guia)
    }
  };

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    );
  }
}

export default withRouter(BuscarGuia);
